import Axios from "axios";
import {
  SET_EVALUATION_LIST,
  UNSET_EVALUATION_LIST,
} from "@/store/mutation-types";

import {
  saveUpdateEvaluationCriteria,
  getEvaluationCriteriaList,
  getEvaluationCriteriaById as getEvaluationCriteriaByIdApi,
} from "@/store/api";

const state = {
  getEvaluationCriteriaList: [],
  editingEvaluation: null,
};

const getters = {
  getEvaluationCriteriaList(state) {
    return state.getEvaluationCriteriaList;
  },
};

const mutations = {
  [SET_EVALUATION_LIST](state, data) {
    state.getEvaluationCriteriaList = data;
  },
  [UNSET_EVALUATION_LIST](state) {
    state.getEvaluationCriteriaList = [];
  },
  setEditingPrOrder(state, evaluation) {
    state.editingEvaluation = evaluation;
  },
};

const actions = {
  saveUpdateEvaluationCriteria({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateEvaluationCriteria, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
  getEvaluationCriteriaList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getEvaluationCriteriaList, data)
        .then(function (response) {
          commit("SET_EVALUATION_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_EVALUATION_LIST");
          reject(error);
        })
        .then((always) => {});
    });
  },
  getEvaluationCriteriaById({commit} , id){
    const getEvaluationCriteriaById = `${getEvaluationCriteriaByIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.get(getEvaluationCriteriaById)
      .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }
};
export default {
  state,
  getters,
  actions,
  mutations,
}